<template>
  <div
    class="d-flex flex-column gr-2 py-1"
    data-qa="diagram_age_stacked"
  >
    <div class="diagram-age-stacked__bar d-flex overflow-hidden rounded bg-primary">
      <div
        v-for="(group, index) in ageGroups"
        :key="group.label"
        class="diagram-age-stacked__segment flex-shrink-0 min-w-0"
        :style="{
          flexGrow: group.frequency,
          backgroundColor: group.color,
        }"
        :data-qa="`diagram_age_stacked_segment_${index}`"
      />
    </div>
    <div class="d-flex flex-wrap ga-2 gc-4">
      <div
        v-for="(group, index) in ageGroups"
        :key="group.label"
        class="d-flex align-center gc-1"
        :data-qa="`diagram_age_stacked_legend_${index}`"
      >
        <span
          class="diagram-age-stacked__dot rounded-circle flex-shrink-0"
          :style="{ backgroundColor: group.color }"
        />
        <span class="text-body-2">{{ group.label }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import usePracticeAgeGroups from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/composables/usePracticeAgeGroups'

const { ageGroups } = usePracticeAgeGroups()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.diagram-age-stacked {
  &__bar {
    height: 24px;
  }

  &__segment + &__segment {
    border-left: 1px solid $ui-kit-bg-gray-0;
  }

  &__dot {
    width: 16px;
    height: 16px;
  }
}
</style>
